import {Component, OnInit, ViewChild} from "@angular/core";

import {CadastroGrupoCarteiraComponent} from "../cadastro-grupo-carteira/cadastro-grupo-carteira.component";
import {GerenciadorRegistrosComponent} from "../gerenciar-registro/gerenciador-registros.component";
import {MatTabChangeEvent} from "@angular/material/tabs";
import {PageService} from "../../shared/layout/services/page.service";
import {ImportacaoLoteComponent} from "../../shared/importacao-lote/importacao-lote.component";
import {MatDialog} from "@angular/material/dialog";
import {TipoUpload} from "../../shared/importacao-lote/tipo-upload";
import {Exporter, XLSXExporter} from "../../shared/export/export";
import {GrupoCarteiraService} from "../grupo-carteira.service";
import {Observable, Subscription} from "rxjs";
import {HttpResponse} from "@angular/common/http";
import {ToastService} from "maps-angular-components";

@Component({
  selector: "app-grupo-carteira",
  templateUrl: "./grupo-carteira.component.html",
  styleUrls: ["./grupo-carteira.component.scss"],
})
export class GrupoCarteiraComponent implements OnInit {
  @ViewChild("cadastroGrupoCarteira", {static: false}) cadastroGrupoCarteira: CadastroGrupoCarteiraComponent;
  @ViewChild("gerenciadorRegistros", {static: false}) gerenciadorRegistros: GerenciadorRegistrosComponent;
  @ViewChild("grupoCarteiraImportacaoLote", {static: false}) grupoCarteiraImportacaoLote: ImportacaoLoteComponent;

  private readonly subscriptions = new Subscription();
  readonly tipo: TipoUpload = TipoUpload.GRUPO_CARTEIRA;

  constructor(private page: PageService,
              private service: GrupoCarteiraService,
              private messageService: ToastService,
              private dialog: MatDialog,
  ) {
  }

  ngOnInit() {
    this.page.defineTitle("GRUPO DE CARTEIRA");
  }

  tabChanged($event: MatTabChangeEvent): void {
    if ($event.index === 0) {
      this.cadastroGrupoCarteira.limparForm();
    } else if ($event.index === 2) {
      this.gerenciadorRegistros.limparForm();
    }
  }

  downloadModelo() {
    const exporter = new XLSXExporter();
    this.doExportPage(this.service.downloadModelo(), exporter);
  }

  doExportPage(observableData: Observable<HttpResponse<Blob>>, exporter: Exporter) {
    this.subscriptions.add(observableData.subscribe(
      (data: HttpResponse<Blob>) => exporter.save(data),
      err => this.messageService.erro(err.error.message)
    ));
  }
}
